<!--
// Re-rendering after the inital browser render will break some
// functionality because most of it is from dom manipulation.
// Only enable updates for new items.
-->
<div class=`str-quickview-carousel ${input.removePrevNextBtnsClass}`>
    <if(!input.removePrevNextBtns)>
        <button class="str-quickview-carousel__prev"
            on-click("scrollPrev")
            data-track=input.trackingPrevious
            aria-label=input.a11yPreviousText>
            <ebay-chevron-left-16-icon/>
        </button>
    </if>
    <div class="str-quickview-carousel__list-wrap">
        <ul class="str-quickview-carousel__list">
            <for|item| of=input.items>
                <li key=item.key
                    class=item.class
                    style=item.style>
                    <${item.renderBody}/>
                </li>
            </for>
        </ul>
    </div>
    <if(!input.removePrevNextBtns)>
        <button class="str-quickview-carousel__next"
            on-click("scrollNext")
            data-track=input.trackingNext
            aria-label=input.a11yNextText>
            <ebay-chevron-right-16-icon/>
        </button>
    </if>
</div>
